import React from 'react'

const Careers = () => {
  return (
    <>
    
      <section className="hero"><br /><br /><br /><br /><br /><br /><br />
      <div className='hero-content'>
            <h1>Careers</h1>  
            </div>  
        </section>
    
    </>
  )
}

export default Careers